import React, { useState } from 'react';
import './Catalogo.css';

/* ─────────────────────────────────────────────────────
   Produtos — adicione, remova ou edite aqui
   category: 'women' | 'men'
───────────────────────────────────────────────────── */
const products = [
  { id: 1,  name: 'TEE D.U CINZA',              price: 69.90,  category: 'women', image: '/images/Clothing/Feminina/CatálogoD.U-images-1.jpg' },
  { id: 2,  name: 'TEE D.U PRETA',              price: 69.90,  category: 'women', image: '/images/Clothing/Feminina/CatálogoD.U-images-2.jpg' },
  { id: 3,  name: 'Camiseta Linha Premium',      price: 79.90,  category: 'men',   image: '/images/Clothing/Masculina/Camiseta1/CatálogoD.U-Masculino1.jpg' },
  { id: 4,  name: 'TEC-D.U',                    price: 129.90, category: 'men',   image: '/images/Clothing/Masculina/Camiseta2/CatálogoD.U-Masculino2.jpg' },
  { id: 5,  name: 'TEE D.U OFF WHITE',           price: 69.90,  category: 'women', image: '/images/Clothing/Feminina/CatálogoD.U-images-3.jpg' },
  { id: 6,  name: 'Camiseta Linha Premium',      price: 79.90,  category: 'men',   image: '/images/Clothing/Masculina/Camiseta3/CatálogoD.U-Masculino3.jpg' },
  { id: 7,  name: 'TEE "MAKE IT SIMPLE"',        price: 79.90,  category: 'women', image: '/images/Clothing/Feminina/CatálogoD.U-images-4.jpg' },
  { id: 8,  name: 'Camiseta Linha Premium',      price: 79.90,  category: 'men',   image: '/images/Clothing/Masculina/Camiseta4/CatálogoD.U-Masculino4.jpg' },
  { id: 9,  name: 'TEE "POWER"',                price: 79.90,  category: 'women', image: '/images/Clothing/Feminina/CatálogoD.U-images-5.jpg' },
  { id: 10, name: 'TEE "CREATE YOUR HAPPINESS"', price: 79.90,  category: 'women', image: '/images/Clothing/Feminina/CatálogoD.U-images-6.jpg' },
];

/* Filtros disponíveis */
const filters = [
  { label: 'TODOS',     value: 'all' },
  { label: 'FEMININO',  value: 'women' },
  { label: 'MASCULINO', value: 'men' },
];

const Catalogo = () => {
  const [filter, setFilter] = useState('all');

  /* Filtragem */
  const filtered = filter === 'all'
    ? products
    : products.filter(p => p.category === filter);

  /* WhatsApp — troque o número aqui */
  const handleBuy = (name) => {
    const msg = `Olá! Me interessei pela peça "${name}" e gostaria de comprar. Poderia me ajudar?`;
    const url = `https://api.whatsapp.com/send/?phone=5584994078838&text=${encodeURIComponent(msg)}&type=phone_number&app_absent=0`;
    window.open(url, '_blank');
  };

  return (
    <section className="cat-section">
      <div className="cat-inner">

        {/* ── Header ───────────────────────────────── */}
        <div className="cat-header cat-fadein" style={{ '--delay': '0s' }}>

          {/* Título */}
          <div>
            {/* Label pequena acima — igual ao Lovable */}
            <p className="cat-label">COLEÇÃO</p>
            <h2 className="cat-title">Catálogo</h2>
          </div>

          {/* Filtros */}
          <div className="cat-filters">
            {filters.map(f => (
              <button
                key={f.value}
                onClick={() => setFilter(f.value)}
                className={`cat-filter-btn ${filter === f.value ? 'cat-filter-btn--active' : ''}`}
              >
                {f.label}
              </button>
            ))}
          </div>

        </div>

        {/* ── Grid de produtos ─────────────────────── */}
        <div className="cat-grid">
          {filtered.map((product, i) => (
            <div
              key={product.id}
              className="cat-card cat-fadein"
              style={{ '--delay': `${i * 0.06}s` }}  /* entrada escalonada */
              onClick={() => handleBuy(product.name)}
            >
              {/* Imagem */}
              <div className="cat-card__img-wrap">
                <img
                  src={process.env.PUBLIC_URL + product.image}
                  alt={product.name}
                  className="cat-card__img"
                />

                {/* Botão que sobe no hover */}
                <div className="cat-card__btn">COMPRAR</div>
              </div>

              {/* Info */}
              <div className="cat-card__info">
                <p className="cat-card__price">R$ {product.price.toFixed(2)}</p>
                <p className="cat-card__name">{product.name}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Catalogo;